// extracted by mini-css-extract-plugin
export default {"p_content":"_65952bc678"};